__webpack_require__.p = "https://order-3p-front.integracommerce.com.br/";